/**
 * Play-button video lightbox. Loaded from snippets/play-button-block.liquid as type="module".
 */

const DIALOG_ID = 'play-button-video-lightbox'

let youtubeApi
let vimeoApi

function loadYouTubeAPI() {
  if (window.YT?.loaded) return Promise.resolve()

  youtubeApi ??= new Promise((resolve) => {
    const previous = window.onYouTubeIframeAPIReady
    window.onYouTubeIframeAPIReady = () => {
      if (typeof previous === 'function') previous()
      resolve()
    }
    const script = document.createElement('script')
    script.src = 'https://www.youtube.com/iframe_api'
    document.body.append(script)
  })

  return youtubeApi
}

function loadVimeoAPI() {
  if (window.Vimeo) return Promise.resolve()

  vimeoApi ??= new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = 'https://player.vimeo.com/api/player.js'
    script.onload = resolve
    document.body.append(script)
  })

  return vimeoApi
}

function playExternal(el) {
  const { videoProvider, videoId } = el.dataset
  if (!videoId) return

  if (videoProvider === 'youtube') {
    loadYouTubeAPI().then(() => {
      const player = new window.YT.Player(el, {
        videoId,
        playerVars: {
          autohide: 0,
          cc_load_policy: 0,
          controls: 1,
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 1,
          rel: 0,
          playlist: videoId,
        },
        events: {
          onReady: () => {
            player.playVideo()
            const iframe = player.getIframe()
            if (iframe) iframe.tabIndex = 0
          },
        },
      })
    })
    return
  }

  if (videoProvider === 'vimeo') {
    loadVimeoAPI().then(() => {
      const player = new window.Vimeo.Player(el, {
        id: videoId,
        controls: true,
        keyboard: false,
      })
      player.play()
      if (player.element) player.element.tabIndex = 0
    })
  }
}

function stopVideo(dialog) {
  const video = dialog.querySelector('video')
  if (video) {
    video.pause()
    video.removeAttribute('src')
    video.querySelectorAll('source').forEach((source) => source.remove())
    video.load()
  }
  dialog.querySelector('[data-play-button-video-body]')?.replaceChildren()
}

function getDialog() {
  let dialog = document.getElementById(DIALOG_ID)
  if (dialog) return dialog

  dialog = document
    .querySelector('[data-play-button-video-lightbox-template]')
    ?.content.querySelector('dialog')
    ?.cloneNode(true)
  if (!dialog) return null

  dialog.id = DIALOG_ID
  document.body.append(dialog)

  const close = () => {
    if (dialog.open) dialog.close()
  }

  dialog.querySelector('[data-play-button-video-close]')?.addEventListener('click', close)
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close()
  })
  dialog.addEventListener('close', () => stopVideo(dialog))

  return dialog
}

function openLightbox(block) {
  const source = block.querySelector('[data-play-button-block-video-container]')
  const dialog = getDialog()
  const body = dialog?.querySelector('[data-play-button-video-body]')
  if (!source || !body) return

  body.replaceChildren(source.cloneNode(true))
  dialog.showModal()

  const video = body.querySelector('[data-play-button-block-video], .play-button-block-video')
  if (!video) return

  if (source.dataset.videoType === 'shopify') {
    video.play?.()?.catch(() => {})
    return
  }

  playExternal(video)
}

document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest('.play-button-block [data-play-button-block]')
    if (!button || button.hasAttribute('data-flash-trigger')) return

    event.preventDefault()
    event.stopImmediatePropagation()

    const block = button.closest('.play-button-block')
    if (block) openLightbox(block)
  },
  true
)
